var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "clipboard-button"
  }, [_c('div', {
    staticClass: "success-copy",
    "class": {
      'active': _vm.success
    }
  }, [_vm._v(" skopírované ")]), _c('div', {
    staticClass: "text-cta pointer",
    on: {
      "click": function click($event) {
        return _vm.copyTextToClipboard();
      }
    }
  }, [_vm._v(" kopírovať ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }